import { useMutation } from "react-query";
import { authApi } from "../api/auth-api";
import { SignInPayload } from "../types/auth/sign-in-payload";

export enum AuthQueryKey {
  SignIn = "SignIn",
}

export const useSignInAdminMutation = () => {
  return useMutation(AuthQueryKey.SignIn, (payload: SignInPayload) =>
    authApi.signInAdmin(payload)
  );
};
